import { render, staticRenderFns } from "./dashboard.view.vue?vue&type=template&id=4001f44e&"
import script from "./dashboard.view.ts?vue&type=script&lang=js&"
export * from "./dashboard.view.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports